export default __webpack_public_path__ + "static/media/trash.a640cab5.svg";